var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext, useState, } from 'react';
import ContentfulLoadError from '../../errors/ContentfulLoadError';
import { useMastheadData } from '../../utils/contentful';
export var FrodorContentfulEntryId = '6ACS5TMQXyfAbP7Uxx5GrZ';
export var DefaultInteractiveElement = function (_a) {
    var customComponent = _a.customComponent, children = _a.children, trackingCategory = _a.trackingCategory, trackingLabel = _a.trackingLabel, props = __rest(_a, ["customComponent", "children", "trackingCategory", "trackingLabel"]);
    var defaultComponent = props.href ? 'a' : 'button';
    var Component = customComponent || defaultComponent;
    var _ = props.trackingCategory, __ = props.trackingLabel, domProps = __rest(props, ["trackingCategory", "trackingLabel"]);
    return (React.createElement(Component, __assign({}, domProps, { onClick: function () {
            var _a;
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props);
        } }), children));
};
var DefaultSiteLogo = function (_a) {
    var label = _a.label, height = _a.height, props = __rest(_a, ["label", "height"]);
    if (process.env.NODE_ENV === 'test') {
        return (React.createElement("div", __assign({ "data-testid": "default-site-logo", "data-label": label, "data-height": height }, props), label || 'Default Logo'));
    }
    var LogoSpotifyForArtists = require('@spotify-internal/encore-web/core').LogoSpotifyForArtists;
    return (React.createElement(LogoSpotifyForArtists, __assign({ condensed: true, label: label, height: height }, props)));
};
var contextDefaults = {
    clientId: '',
    mastheadData: null,
    language: {
        locale: 'en-US',
        dir: 'ltr',
        onClick: function () { }
    },
    loginRedirectUri: 'https://artists.spotify.com/c',
    logoutRedirectUri: 'https://artists.spotify.com/home',
    homeUrl: 'https://artists.spotify.com/home/?ref=logo',
    claimUrl: 'https://artists.spotify.com/claim',
    InteractiveElement: DefaultInteractiveElement,
    siteLogo: DefaultSiteLogo,
    secondaryNavigation: undefined,
    setSecondaryNavigation: function () { return undefined; }
};
var S4XMastheadContext = createContext(contextDefaults);
export var useS4XMastheadContext = function () {
    return useContext(S4XMastheadContext);
};
export var S4XMastheadProvider = function (_a) {
    var children = _a.children, _b = _a.clientId, clientId = _b === void 0 ? contextDefaults.clientId : _b, _c = _a.loginRedirectUri, loginRedirectUri = _c === void 0 ? contextDefaults.loginRedirectUri : _c, _d = _a.logoutRedirectUri, logoutRedirectUri = _d === void 0 ? contextDefaults.logoutRedirectUri : _d, _e = _a.homeUrl, homeUrl = _e === void 0 ? contextDefaults.homeUrl : _e, _f = _a.claimUrl, claimUrl = _f === void 0 ? contextDefaults.claimUrl : _f, language = _a.language, _g = _a.contentfulEntryId, contentfulEntryId = _g === void 0 ? FrodorContentfulEntryId : _g, _h = _a.InteractiveElement, InteractiveElement = _h === void 0 ? contextDefaults.InteractiveElement : _h, _j = _a.siteLogo, siteLogo = _j === void 0 ? contextDefaults.siteLogo : _j;
    var _k = useMastheadData(language.locale, contentfulEntryId), mastheadData = _k.data, error = _k.error;
    var _l = useState(undefined), secondaryNavigation = _l[0], setSecondaryNavigation = _l[1];
    if (error) {
        throw new ContentfulLoadError(error);
    }
    return (React.createElement(S4XMastheadContext.Provider, { value: {
            clientId: clientId,
            mastheadData: mastheadData,
            language: language,
            loginRedirectUri: loginRedirectUri,
            logoutRedirectUri: logoutRedirectUri,
            homeUrl: homeUrl,
            claimUrl: claimUrl,
            InteractiveElement: InteractiveElement,
            siteLogo: siteLogo,
            secondaryNavigation: secondaryNavigation,
            setSecondaryNavigation: setSecondaryNavigation
        } }, children));
};
